import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'

export const TRANSFORMER = graphql.transformers.IN.nonNull(
  graphql.transformers.IN.object<
    ents.extra.space.Record.OrganizationAssignment.Input,
    graphql.schema.OrganizationAssignmentInput
  >({
    organizationId: transformers.PASS_THROUGH,
  }),
)
